module.exports = __webpack_public_path__ + "img/explore-2.5ef93719.jpg";